import { useGetFetch } from '../reactQuery';
import { PRODUCT_BANK_API } from '../../../constant/api_url';
import { Input } from '../../../types/input.types';

export const useAvailableInputsForProductBankById = (id: number | string) => {
  return useGetFetch<Input[]>(`${PRODUCT_BANK_API}/${id}/available-inputs`);
};
